import React, { useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdDownloadForOffline } from "react-icons/md";
import { BsCloudUpload } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { createHochladenForAccident, deleteHochladen } from "../redux/apiCalls/accidentApiCall";
import { ClipLoader } from "react-spinners";
function HochladenPartner() {
        const data = [
            { id: 1, name: "Subject", seit: "01.02.23", ort: "Location 1" },
            { id: 2, name: "Subject", seit: "15.11.22", ort: "Location 2" },
          ];
          const [isModalOpen, setIsModalOpen] = useState(false);
          const role = sessionStorage.getItem('role');
          const [photoUrl, setPhotoUrl] = useState(""); 
          const fileInputRef = useRef(null);
          const downloadPhoto = async (url) => {
            try {
              const response = await fetch(url);
              const blob = await response.blob();
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = url.split('/').pop();
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(link.href);
            } catch (error) {
              console.error("Download failed:", error);
            }
          };

          const {lastAccident, partner,createPhotoLoading, getLoading} = useSelector(state => state.accident)
  const formData = new FormData()
  const [image, setImage] = useState();
  const [imageState, setImageState] = useState(null); 
  const [imageText, setImageText] = useState("");
  const dispatch = useDispatch()

  const handleUpload = () => {

    if(!image){
      return
    }
    

    formData.append("image", image)
    formData.append("kind", imageText);
    formData.append("user", partner.user._id)

    dispatch(createHochladenForAccident(formData, "partner"))
  }

  const renderDate = (e) =>{
    const dateString = e;
    const date = new Date(dateString);

    // Format the date to "DD.MM.YYYY"
    const day = String(date.getUTCDate()).padStart(2, '0'); // Get day and pad with zeros if needed
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Get month (0-indexed, so add 1) and pad
    const year = date.getUTCFullYear(); // Get full year

    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate
  }
        
          return (
            <div className="overflow-x-auto">
               {partner.user.hochladen.length>0 ? <table className="min-w-full border border-gray-300 rounded-lg shadow-lg">
        {/* الجدول العلوي */}
        <thead className="bg-gradient-to-r from-black to-[#DAA520] text-white">
          <tr>
            <th className="px-6 py-3 text-left text-sm font-[700] border-b border-gray-400">Hochladen</th>
            <th className="px-6 py-3 text-left text-sm font-[700] border-b border-gray-400">ADatum</th>
            <th className="px-6 py-3 text-center text-sm font-[700] border-b border-gray-400">Aktion</th>
          </tr>
        </thead>

        {/* جسم الجدول */}
        <tbody>
          {partner.user.hochladen.map((row, index) => {    
            console.log(row);
            
            return (
              <tr
                key={row.id}
                className={`${
                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                } hover:bg-gray-200 transition-all`}
              >
                <td className="px-6 py-[5px] text-sm font-[700] border-b border-gray-300">
                  <p>{row.kind}</p>
                </td>
                <td className="px-6 py-[5px] text-sm font-[700] border-b border-gray-300">{renderDate(row.createdAt)}</td>
                {}
                <td className="px-6 py-[5px] text-center border-b border-gray-300">
                  {/* الأزرار */}
  {role ==="admin"&&<button onClick={() => {
    dispatch(deleteHochladen(row._id, "partner"))
  }} className="text-[#fe4040] transition-all hover:text-[#d85f5f] mx-2">
                    <RiDeleteBin6Line className="text-[22px]" />
                  </button>}
                      <button onClick={() => setImageState(row.hochPhoto.url)} className="text-[#3dba50] transition-all hover:text-green-700 mx-2">
                        {/* <FaEye className="text-[22px]" /> */}
                      </button>
                      <button className="text-[rgb(255,189,89)] transition-all hover:text-blue-700">
                          <MdDownloadForOffline onClick={() => {
                            downloadPhoto(row.hochPhoto.url)
                          }} className="text-[25px]" />
                      </button>
                      <div className="text-[rgb(255,189,89)] transition-all hover:text-blue-700 ml-[2px]">
                          
                          {getLoading ?<ClipLoader color="#000"/> :""}
                      </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>:<div className="text-center mt-[10px] font-bold text-[20px]">Es wurde noch keine Unterlagen hochgeladen</div>}
              
              <div className="flex justify-center items-center mt-6 absolute bottom-[40px] left-[50%]">
          <button onClick={() => setIsModalOpen(true)} className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border-[1px] border-[black] rounded shadow-md">
            + Neues Dokument hochladen
          </button>
        </div>
              {/* النافذة المنبثقة */}
              {isModalOpen && (
                    <div className="fixed inset-0 bg-[#333] bg-opacity-[0.5] flex items-center justify-center z-50">
                      <div
                        className="bg-[rgb(237,237,235)] p-6 rounded-lg shadow-lg w-[600px] animate-fade-in-down"
                        style={{ animationDuration: "0.3s" }}
                      >
                        <h2 className="text-lg font-bold mb-4 text-center">Daten Name</h2>
                        <div className="flex items-center mb-4 justify-between">
                          <div className="flex items-center">
                          <input
                          onChange={(e) => {
                            setImage(e.target.files[0])
                          }}
                            type="file"
                            ref={fileInputRef}
                            className="hidden"
                            id="fileInput"
                          />
                      <label
          htmlFor="fileInput"
          className="block text-sm text-gray-500 py-2 px-4 rounded-lg border border-gray-300 bg-blue-50 text-blue-700 hover:bg-blue-100 cursor-pointer"
        >
          Datei auswählen
        </label>
        <span id="fileName" className="ml-2 text-sm text-gray-500">
          Keine Datei ausgewählt
        </span>
                          </div>
                          {createPhotoLoading ?<div className="bg-blue-500 font-[700] text-white px-4 py-2 rounded-r-md hover:bg-blue-600">
                            <ClipLoader color="fff"/>
                          </div> : <button onClick={handleUpload} className="bg-blue-500 font-[700] text-white px-4 py-2 rounded-r-md hover:bg-blue-600">
                          UPLOAD
                          </button>}
                          
                         
                        </div>
                           <input type="text" value={imageText} onChange={(e) => {setImageText(e.target.value)}} placeholder="Bildname / Datei" className="bg-[#fff] p-[10px] rounded-lg shadow-lg animate-fade-in-down outline-none w-[100%]"/>
                        <div className="flex justify-center">
                          <div className="text-blue-500 text-4xl">
                            <i className="fas fa-cloud-upload-alt"></i>
                          </div>
                        </div>
                        <div className="flex justify-center mt-4">
                          <button
                            onClick={() => setIsModalOpen(false)}
                            className="bg-gray-300 px-4 py-2 rounded-md hover:bg-gray-400"
                          >
                            Close
                          </button>
                          <button
                            className=" px-4 py-2 cursor-pointer bg-transparent"
                          >
                            <BsCloudUpload className="text-[29px] text-[#54d8fb] transition-all hover:text-blue-700" />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                   {imageState && (
        <div className="fixed inset-0 bg-[#333] bg-opacity-[0.5] flex items-center justify-center z-50">
          <div
            className="bg-[rgb(237,237,235)] p-6 rounded-lg shadow-lg animate-fade-in-down"
            style={{ animationDuration: "0.3s" }}
          >
            <h2 className="text-lg font-bold mb-4 text-center">Image Preview</h2>
            <img src={imageState} alt="Preview" className="max-w-full max-h-[80vh] mx-auto" />
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setImageState(null)}
                className="bg-gray-300 px-4 py-2 rounded-md hover:bg-gray-400"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
            </div>
    )
}

export default HochladenPartner
